import { TABLE_ROW_MIN_HEIGHT } from "../constants";

export const resolveFrozenRowCount = (
  tableFrozenRowsCount: number | undefined,
  totalVisualRows: number,
): number => Math.max(0, Math.min(tableFrozenRowsCount ?? 0, totalVisualRows));

export const computeFrozenRowTops = (
  frozenCount: number,
  iterationOrder: number[],
  tableRowHeights: number[],
): number[] => {
  const tops: number[] = [];
  let acc = 0;
  for (let v = 0; v < frozenCount; v++) {
    tops[v] = acc;
    acc += tableRowHeights[iterationOrder[v]] ?? TABLE_ROW_MIN_HEIGHT;
  }
  return tops;
};
